export default function* () {
    const colors = ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3']

    let i = 0;
    while (true) {
        if (i >= colors.length) i = 0;
        yield colors[i++]
    }
}
